import { datadogRum } from '@datadog/browser-rum';

import { isSafeRedirect } from './isSafeRedirect';

const ALLOWED_REDIRECT_DOMAINS = ['indeed.com', 'indeed.net', 'indeedflex.com'];

const getUrlHostname = (maybeUrl: string): string | null => {
    try {
        return new URL(maybeUrl).hostname;
    } catch {
        return null;
    }
};
export const verifyAllowedHostName = (maybeUrl: string): boolean => {
    const hostName = getUrlHostname(maybeUrl);
    if (!hostName) return false;
    const domainPlusTld = hostName.split('.').slice(-2).join('.');

    return ALLOWED_REDIRECT_DOMAINS.includes(domainPlusTld);
};

const getSafeRedirectTo = (redirectTo: string | null): string | null => {
    if (redirectTo && isSafeRedirect(redirectTo, ALLOWED_REDIRECT_DOMAINS)) {
        return redirectTo;
    } else if (redirectTo) {
        datadogRum.addError(new Error(`Unsafe redirect_to value detected: ${redirectTo}`));
    }

    return null;
};

export const getRedirectUrl = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectTo = urlParams.get('redirect_to');
    return getSafeRedirectTo(redirectTo);
};

export const getRedirectUrlFromStorage = (): string | null => {
    const redirectTo = sessionStorage.getItem('redirect_to');
    return getSafeRedirectTo(redirectTo);
};

export const indexLocation = {
    pathname: '/',
    search: window.location.search,
};
